var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loaded)?_c('div',{staticClass:"loadingFalse tableContainer"},[_vm._m(0)]):_c('div',[_c('weather',{attrs:{"title":_vm.station,"wind-units":"m/s","current-day":_vm.currentDay,"forecast":_vm.forecast}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('span',{staticClass:"preloader-inner"},[_c('span',{staticClass:"preloader-inner-circle"})])])
}]

export { render, staticRenderFns }